import React from 'react';
import { motion } from 'framer-motion';
import { ExclamationCircleOutlined, PoweroffOutlined, CheckCircleOutlined } from '@ant-design/icons';
import ChatHeader from './ChatHeader';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import CustomerInfoForm from './CustomerInfoForm';
import FeedbackForm from './FeedbackForm';

const ChatWindow = ({
  messages,
  isLoading,
  error,
  onSelectOption,
  onClose,
  onMinimize,
  onSendBotMessage,
  customerInfo,
  onCustomerInfoSubmit,
  chatPhase = 'chat',
  onConfirmClose,
  onCancelClose,
  onFeedbackComplete,
  sessionId,
  compareMode,
  selectedCards,
  onCardToggle,
  onCompare,
  checklistMode,
  selectedCriteria,
  onCriteriaToggle,
  onRecommend,
  wizardMode,
  wizardSteps,
  currentStepIndex,
  wizardSelections,
  onWizardToggle,
  onWizardNext,
  onWizardPrev,
  onWizardSubmit,
  latestOptionSetId,
}) => {

  const renderChatContent = () => {
    if (!customerInfo) {
      return <CustomerInfoForm onSubmit={onCustomerInfoSubmit} />;
    }

    if (chatPhase === 'confirm-close') {
      return (
        <div className="chat-confirm-close">
          <div className="chat-confirm-close-icon">
            <PoweroffOutlined />
          </div>
          <h3 className="chat-confirm-close-title">Sohbeti Sonlandır</h3>
          <p className="chat-confirm-close-text">
            Sohbeti kapatmak istediğinize emin misiniz?
          </p>
          <div className="chat-confirm-close-actions">
            <button className="chat-confirm-btn-cancel" onClick={onCancelClose}>
              İptal
            </button>
            <button className="chat-confirm-btn-confirm" onClick={onConfirmClose}>
              Kapat
            </button>
          </div>
        </div>
      );
    }

    // Puan gonderildikten sonra: widget KAPANMAZ, tesekkur mesaji pencerenin
    // icinde gosterilir. Kapatma kararini kullanici verir — embed edilmis
    // sitede kirpilmis bir toast gorunmesin diye.
    if (chatPhase === 'thanks') {
      return (
        <div className="chat-confirm-close">
          <div className="chat-confirm-close-icon">
            <CheckCircleOutlined />
          </div>
          <h3 className="chat-confirm-close-title">Teşekkürler!</h3>
          <p className="chat-confirm-close-text">
            Geri bildiriminiz bize ulaştı. Görüşleriniz hizmetimizi
            geliştirmemize yardımcı oluyor.
          </p>
          <div className="chat-confirm-close-actions">
            <button className="chat-confirm-btn-confirm" onClick={onClose}>
              Kapat
            </button>
          </div>
        </div>
      );
    }

    if (chatPhase === 'feedback') {
      return (
        <FeedbackForm
          sessionId={sessionId}
          customerName={customerInfo ? `${customerInfo.name} ${customerInfo.surname}` : ''}
          onComplete={onFeedbackComplete}
        />
      );
    }

    return (
      <>
        {error && (
          <div className="chat-error-banner">
            <ExclamationCircleOutlined />
            {error}
          </div>
        )}

        <ChatMessages
          messages={messages}
          isLoading={isLoading}
          latestOptionSetId={latestOptionSetId}
          onSelectOption={onSelectOption}
          compareMode={compareMode}
          selectedCards={selectedCards}
          onCardToggle={onCardToggle}
          onCompare={onCompare}
          checklistMode={checklistMode}
          selectedCriteria={selectedCriteria}
          onCriteriaToggle={onCriteriaToggle}
          onRecommend={onRecommend}
          wizardMode={wizardMode}
          wizardSteps={wizardSteps}
          currentStepIndex={currentStepIndex}
          wizardSelections={wizardSelections}
          onWizardToggle={onWizardToggle}
          onWizardNext={onWizardNext}
          onWizardPrev={onWizardPrev}
          onWizardSubmit={onWizardSubmit}
        />

        <ChatInput
          onSend={onSendBotMessage}
          disabled={isLoading}
        />
      </>
    );
  };

  return (
    <motion.div
      className="chat-window"
      initial={{ opacity: 0, y: 24, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 24, scale: 0.96 }}
      transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
    >
      <ChatHeader onClose={onClose} onMinimize={onMinimize} />
      {renderChatContent()}
      <div className="chat-powered-by">
        Powered by{' '}
        <a href="https://www.lidyateknoloji.com/" target="_blank" rel="noopener noreferrer">
          Lidya Teknoloji
        </a>
      </div>
    </motion.div>
  );
};

export default ChatWindow;
